import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { SubAccountIdContext } from '@flipster/r230522/normal-sub/sub-account';
import { Providers } from '@flipster/react/providers/providers';

import { SymbolContext } from '../../symbol/bunja';
import { ParentIdContext, PositionTypeContext } from '../bunja';
import type { TpslButtonStateProps, TpslIdentity } from './identity';
import { tpslButtonBunja } from './state';
import { TpslButtonEmpty } from './tpsl-button-empty';
import { TpslButtonMulti } from './tpsl-button-multi';
import { TpslButtonSingle } from './tpsl-button-single';

export { getTpslIdentity } from './identity';
export type { TpslButtonPosition, TpslIdentity } from './identity';

interface Props extends TpslButtonStateProps, TpslIdentity {}

/** count(0/1/복수)에 따라 상태 컴포넌트를 고르는 dispatcher. Context 스코프 안에서 bind 없이 구독한다. */
const TpslButtonDispatcher = (props: TpslButtonStateProps) => {
  const { tpslType } = props;
  const { tpCountAtom, slCountAtom } = useBunja(tpslButtonBunja);
  const count = useAtomValue(tpslType === 'tp' ? tpCountAtom : slCountAtom);

  if (count === 0) return <TpslButtonEmpty {...props} />;
  if (count === 1) return <TpslButtonSingle {...props} />;
  return <TpslButtonMulti {...props} />;
};

/**
 * TP/SL 관리 버튼.
 *
 * 식별자(symbol/type/id)를 Context로 주입하는 게 유일한 역할이다. 이후 tpslButtonBunja가 그 식별자를
 * atom으로 내려주므로, 하위 상태 컴포넌트들은 position을 몰라도 필요한 값만 bunja에서 구독한다.
 * (position 객체는 받지 않는다 — 호출부가 getTpslIdentity로 식별자만 뽑아 넘긴다.)
 */
export const TpslButton = ({ symbol, positionType, parentId, ...stateProps }: Props) => {
  return (
    <Providers
      providers={
        <>
          <SymbolContext value={symbol} />
          <PositionTypeContext value={positionType} />
          <ParentIdContext value={parentId} />
          <SubAccountIdContext value={stateProps.accountId} />
        </>
      }
    >
      <TpslButtonDispatcher {...stateProps} />
    </Providers>
  );
};
